export const ROOM_THUMBNAIL_PROPERTY = '346x260';

// From Accor API
export enum RoomCategory {
  Room = 'ROOM',
  Suite = 'SUITE',
  Villa = 'VILLA',
  Penthouse = 'PENTHOUSE',
}

export const RoomCategoryOrder = [
  RoomCategory.Room,
  RoomCategory.Suite,
  RoomCategory.Villa,
];

export const HotelLoyaltyStatus = {
  ParticipatingHotel: 'PARTICIPATING_HOTEL',
  PartnerHotel: 'PARTNER_HOTEL',
  PartnerHotelHuazhu: 'PARTNER_HOTEL_HUAZHU',
  NonParticipating: 'NON_PARTICIPATING',
  Unknown: 'UNKNOWN',
};

export const DefaultStayDates = {
  DayToAddFromToday: 21,
  StayDurationInDays: 5,
};
